import OverFlowTooltipWithTabsMui from "../../../common/OverFlowTooltipWithTabsMui";

function TaggedBookmarkListName({bookmarkListText, className=''}) {
    return (
        <OverFlowTooltipWithTabsMui
            className={className}
            value={bookmarkListText ? bookmarkListText : '_'}
        />
    );
}

export default TaggedBookmarkListName;